import { lazy } from "react";
import { renderRoutes } from "./GenerateRoute";
import type { AppLayoutRoute } from "./route";
import MainLayout from "@/layouts/MainLayout";
import AdminLayout from "@/features/content/AdminLayout";

const HomePage = lazy(() => import("@/features/articles/pages/HomePage"));
const ArticleDetailPage = lazy(() => import("@/features/articles/pages/ArticleDetailPage"));
const CategoryPage = lazy(() => import("@/features/articles/pages/CategoryPage"));
const AboutPage = lazy(() => import("@/features/articles/pages/AboutPage"));
const OrderPage = lazy(() => import("@/features/intake/pages/OrderPage"));
const ConfirmationPage = lazy(() => import("@/features/confirmation/pages/ConfirmationPage"));
const RegisterPage = lazy(() => import("@/features/auth/pages/RegisterPage"));
const LoginPage = lazy(() => import("@/features/auth/pages/LoginPage"));
const EmailConfirmationPage = lazy(() => import("@/features/auth/pages/EmailConfirmationPage"));
const ForgotPasswordPage = lazy(() => import("@/features/auth/pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("@/features/auth/pages/ResetPasswordPage"));

const AdminDashboardPage = lazy(() => import("@/features/content/dashboard/AdminDashboardPage"));
const ArticlesListPage = lazy(() => import("@/features/content/articles/ArticlesListPage"));
const ArticleEditorPage = lazy(() => import("@/features/content/articles/ArticleEditorPage"));
const NewslettersListPage = lazy(() => import("@/features/content/newsletters/NewslettersListPage"));
const NewsletterEditorPage = lazy(() => import("@/features/content/newsletters/NewsletterEditorPage"));
const MediaLibraryPage = lazy(() => import("@/features/content/media/MediaLibraryPage"));
const ConceptsPage = lazy(() => import("@/features/content/concepts/ConceptsPage"));
const TickersPage = lazy(() => import("@/features/content/tickers/TickersPage"));

export const routes: AppLayoutRoute[] = [
  {
    layout: MainLayout,
    isPublic: true,
    routes: [
      { path: "/", component: HomePage, name: "Home", title: "AheadMetric" },
      { path: "/article/:slug", component: ArticleDetailPage, name: "Article", title: "Article" },
      { path: "/category/:category", component: CategoryPage, name: "Category", title: "Category" },
      { path: "/about", component: AboutPage, name: "About", title: "About" },
      { path: "/order", component: OrderPage, name: "Order", title: "Order Analysis" },
      { path: "/confirmation", component: ConfirmationPage, name: "Confirmation", title: "Order Confirmation" },
      { path: "/register", component: RegisterPage, name: "Register", title: "Create Account" },
      { path: "/login", component: LoginPage, name: "Login", title: "Sign In" },
      { path: "/auth/confirm", component: EmailConfirmationPage, name: "EmailConfirmation", title: "Confirm Email" },
      { path: "/forgot-password", component: ForgotPasswordPage, name: "ForgotPassword", title: "Reset Password" },
      { path: "/reset-password", component: ResetPasswordPage, name: "ResetPassword", title: "Set New Password" },
    ],
  },
  {
    layout: AdminLayout,
    isPublic: false,
    routes: [
      { path: "/admin", component: AdminDashboardPage, name: "AdminDashboard", title: "Dashboard" },
      { path: "/admin/articles", component: ArticlesListPage, name: "ArticlesList", title: "Articles" },
      { path: "/admin/articles/new", component: ArticleEditorPage, name: "ArticleNew", title: "New Article" },
      { path: "/admin/articles/:id", component: ArticleEditorPage, name: "ArticleEdit", title: "Edit Article" },
      { path: "/admin/newsletters", component: NewslettersListPage, name: "NewslettersList", title: "Newsletters" },
      { path: "/admin/newsletters/new", component: NewsletterEditorPage, name: "NewsletterNew", title: "New Newsletter" },
      { path: "/admin/newsletters/:id", component: NewsletterEditorPage, name: "NewsletterEdit", title: "Edit Newsletter" },
      { path: "/admin/media", component: MediaLibraryPage, name: "MediaLibrary", title: "Media Library" },
      { path: "/admin/concepts", component: ConceptsPage, name: "Concepts", title: "Concepts" },
      { path: "/admin/tickers", component: TickersPage, name: "Tickers", title: "Tickers" },
    ],
  },
];

export const Routes = renderRoutes(routes);
